import { render } from "./CommentBox.vue?vue&type=template&id=8b6a18ca&ts=true"
import script from "./CommentBox.vue?vue&type=script&lang=ts"
export * from "./CommentBox.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/lizheming/Desktop/workspace/waline/waline/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__